import { IntlProvider } from 'react-intl';

import { Modal } from 'antd';
import AppLocale from 'lngProvider';

import IntlMessages from '@src/util/IntlMessages';

import { createBaseActionButtons } from './baseActionButtons';
import { getChartAccess } from './chartAccess';

export const getCounterActionButtons = ({
  handleEdit,
  handleDelete,
  handleDownload,
  downloading,
  loading,
  locale,
  widget,
  additionalProps = {},
}) => {
  const baseButtons = createBaseActionButtons({
    handleEdit,
    handleDelete,
    handleDownload,
    downloading,
    ...getChartAccess(additionalProps.boardSelected),
    iconSize: 'sm',
  });

  const handleTriggerInfo = () => {
    const getLocalizedComponent = idIntl => (
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <IntlMessages id={idIntl} />
      </IntlProvider>
    );

    const currentAppLocale = AppLocale[locale?.locale] || AppLocale.en;
    const title =
      <span className="gx-text-primary">
        {getLocalizedComponent('dashboards.chart.form.description')}
      </span>
    const content = (
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <div>
          <p className="ant-card-meta-description">{widget?.description}</p>
        </div>
      </IntlProvider>
    );
    return Modal.info({
      title,
      content,
      okText: getLocalizedComponent('button.ok'),
      centered: true,
      width: '300px',
    });
  };

  const infoButton = {
    iconName: 'info',
    action: handleTriggerInfo,
    type: 'secondary',
    iconSize: 'sm',
    disabled: loading,
  };

  let buttons = [...baseButtons];
  if (widget?.description) {
    buttons.push(infoButton);
  }

  return buttons;
};
